// extracted by mini-css-extract-plugin
export default {"productDescription":"W_-z","featuredDescription":"X_-z","description":"Y_-z","more":"Z_-z","descriptionSku":"__-z"};